import { n as t } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const l = {
  name: "NcVNodes",
  props: {
    /**
     * The vnodes to render
     */
    vnodes: {
      type: [Array, Object],
      default: null
    }
  },
  /**
   * The render function to display the component
   *
   * @param {Function} h The function to create VNodes
   * @return {object} The created VNode
   */
  render(c) {
    var e, n, s;
    return this.vnodes || ((e = this.$slots) == null ? void 0 : e.default) || ((s = (n = this.$scopedSlots) == null ? void 0 : n.default) == null ? void 0 : s.call(n));
  }
}, o = null, r = null;
var a = /* @__PURE__ */ t(
  l,
  o,
  r,
  !1,
  null,
  null,
  null,
  null
);
const u = a.exports;
export {
  u as default
};
